var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_405)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.98131C2 4.46147 6.52221 0 11.9923 0C17.4778 0 22 4.46147 22 9.98131C22 12.7628 21.0082 15.3452 19.3759 17.5339C17.5751 19.9482 15.3555 22.0518 12.8571 23.7029C12.2853 24.0845 11.7693 24.1133 11.1417 23.7029C8.6291 22.0518 6.40951 19.9482 4.62412 17.5339C2.99057 15.3452 2 12.7628 2 9.98131ZM8 10.0339C8 12.2539 9.79263 14 11.9907 14C14.1901 14 16 12.2539 16 10.0339C16 7.83108 14.1901 6 11.9907 6C9.79263 6 8 7.83108 8 10.0339Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.48ac4f2e74eb2591e62ca16ef2e50fc2.svg";
export { ForwardRef as ReactComponent };